import { Component, Input, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Logger } from '@app/core/logger.service';
import { MultimediaRoutesService } from '@app/multimedia/services/multimedia-routes.service';
import { FirebaseService } from '@app/shared/services/firebase/firebase.service';
const log = new Logger('AlgorithmsComponent');

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
})
export class CarouselComponent implements OnInit {
  @Input() ref: string;
  public items: any[] = [];
  public slidesPerView = 1;
  config = {
    autoplay: true,
    loop: true,
  }
  constructor(
    private fireService: FirebaseService,
    private conectimedRoutes: MultimediaRoutesService,
    private platform: Platform
  ) { }

  ngOnInit() {
    this.platform.ready().then(() => {
      this.updateSlidesPerView();
      this.platform.resize.subscribe(() => this.updateSlidesPerView());
    });
    this.carousel();
  }

  updateSlidesPerView(): void {
    const width = this.platform.width();
    if (width >= 1600) {
      this.slidesPerView = 3.5;
    } else if (width >= 1400) {
      this.slidesPerView = 3;
    } else if (width >= 1200) {
      this.slidesPerView = 2.5;
    } else if (width >= 992) {
      this.slidesPerView = 2;
    } else if (width >= 768) {
      this.slidesPerView = 1.5;
    } else {
      this.slidesPerView = 1;
    }
  }

  async carousel() {
    try {
      let resp: any;
      if (this.ref) {
        resp = await this.fireService.afs.collection('posts').ref
          .where('is_outstanding', '==', true)
          .where('category', '==', this.fireService.afs.doc(this.ref).ref)
          .where('status', '==', 'active')
          .orderBy('publication_date', 'desc')
          .get();
      } else {
        resp = await this.fireService.afs.collection('posts').ref
          .where('is_outstanding', '==', true)
          .where('status', '==', 'active')
          .orderBy('publication_date', 'desc')
          .get();
      }
      this.items = resp.docs.map((item: any) => {
        let data: any = item.data();
        const id: string = item.id;
        data.routing = this.conectimedRoutes.mapRoute(data.category, id, data.title) || {};
        return { id, ...data }
      });
    } catch (error) {
      log.error(error);
    }
  }
}
